import 'css-chunksrc/client/common/filterMenu/zones/styles.scss';export default {
  "header": "_header_c9mqm_1",
  "title": "_title_c9mqm_10",
  "loader": "_loader_c9mqm_17"
};